import React from "react";
import _ from "lodash";
import { inputClass } from "helpers/StyleClass";
import { MATCH } from "components/network/units/Utils";

class OptionMultiList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
    };

    this.handleSelectChanged = this.handleSelectChanged.bind(this);
    this.handleSelectAllChanged = this.handleSelectAllChanged.bind(this);
    this.handleSwitchMatchChanged = this.handleSwitchMatchChanged.bind(this);
  }

  handleSelectChanged(key) {
    const { selected, handleSelectChanged, allKey } = this.props;
    if (handleSelectChanged) {
      const parsedSelected = selected === allKey ? [] : selected;
      const result = parsedSelected.includes(key)
        ? parsedSelected.filter((k) => k !== key)
        : [...parsedSelected, key];
      handleSelectChanged(result.length === 0 ? allKey : result);
    }
  }

  handleSelectAllChanged(list, isSelected) {
    const { handleSelectChanged, selected, allKey } = this.props;

    if (handleSelectChanged) {
      const parsedSelected = selected === allKey ? [] : selected;
      const result = isSelected
        ? _.difference(parsedSelected, list)
        : _.uniq([...parsedSelected, ...list]);
      handleSelectChanged(result.length === 0 ? allKey : result);
    }
  }

  handleSwitchMatchChanged(value) {
    const { handleMatchChanged } = this.props;

    if (handleMatchChanged) {
      handleMatchChanged(value);
    }
  }

  render() {
    const {
      selected,
      match,
      allKey,
      options,
      isSearchable = true,
      isSwitchMatch = false,
    } = this.props;

    const { inputValue } = this.state;

    const parsedSelected = selected === allKey ? [] : selected;

    const optKeyList = _.keys(options);

    const filteredList = _.filter(
      optKeyList,
      (key) =>
        inputValue === "" ||
        options[key].text.toLowerCase().includes(inputValue.toLowerCase())
    );

    const filteredSelected = _.filter(parsedSelected, (key) =>
      filteredList.includes(key)
    );

    const sortedList = _.reverse(
      _.sortBy(filteredList, [
        (key) => {
          return options[key].count || 0;
        },
      ])
    );

    return (
      <div>
        {optKeyList.length > 0 && (
          <>
            {isSearchable && (
              <div className="mb-1" style={{ width: "400px" }}>
                <div className="flex items-center">
                  <button
                    type="button"
                    className="my-1 ml-2 font-semibold text-blue-600"
                    onClick={() => {
                      this.handleSelectAllChanged(
                        filteredList,
                        filteredSelected.length === filteredList.length
                      );
                    }}
                  >
                    {filteredSelected.length === filteredList.length
                      ? "Clear"
                      : "Select"}{" "}
                    All{" "}
                    {inputValue !== ""
                      ? `(${filteredList.length} result${
                          filteredList.length > 1 ? "s" : ""
                        })`
                      : ""}
                  </button>

                  {selected === allKey ? (
                    <div className="ml-auto py-1 text-gray-600">
                      {inputValue === ""
                        ? `${filteredList.length} items`
                        : `${filteredList.length} results (${optKeyList.length} total)`}
                    </div>
                  ) : (
                    <div className="ml-auto py-1 text-gray-600">
                      {inputValue === ""
                        ? `${parsedSelected.length} selected of ${filteredList.length} items`
                        : `${filteredSelected.length} selected of ${filteredList.length} results (${parsedSelected.length} of ${optKeyList.length} total)`}
                    </div>
                  )}
                </div>
                <input
                  className={inputClass + " w-24"}
                  value={inputValue}
                  placeholder="Search by name"
                  onChange={(e) =>
                    this.setState({ inputValue: e.target.value })
                  }
                />
              </div>
            )}
            {isSwitchMatch && (
              <div className="mb-1 flex items-center gap-2 pl-2">
                <div className="text-xs text-gray-600">Match for</div>
                <div className="border rounded divide-x inline-flex overflow-hidden border-gray-400">
                  {_.values(MATCH).map((item) => (
                    <button
                      type="button"
                      className={`focus:outline-none px-2 text-xs font-semibold leading-5 ${
                        match === item
                          ? "bg-indigo-200 text-indigo-900"
                          : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                      }`}
                      onClick={() => this.handleSwitchMatchChanged(item)}
                      key={item}
                    >
                      {_.startCase(item.toLowerCase())}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </>
        )}

        <div
          className="flex flex-wrap items-center gap-x-2 gap-y-1 overflow-y-auto"
          style={{ maxHeight: "160px" }}
        >
          {sortedList.map((key) => {
            return (
              <button
                key={key}
                type="button"
                className={`rounded px-2 py-1 font-semibold ${
                  selected.includes(key)
                    ? "bg-indigo-200 text-indigo-900"
                    : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
                }`}
                onClick={() => this.handleSelectChanged(key)}
              >
                {options[key].text || key}
                {options[key].count !== undefined
                  ? ` (${options[key].count})`
                  : ""}
              </button>
            );
          })}
          {sortedList.length === 0 && (
            <div className="py-1 pl-2 text-gray-500">No item found.</div>
          )}
        </div>
      </div>
    );
  }
}

export default OptionMultiList;
